import { t } from 'i18next'
import z from 'zod'

import { formaPagamentoComissaoEnum } from '@/features/proposta/interfaces/proposta.enums'

export const ImobiliariaCorretoresSchema = z.discriminatedUnion('incluirParticipacoes', [
  z.object({
    incluirParticipacoes: z.literal('Sim'),
    formaPagamentoComissao: z.enum(formaPagamentoComissaoEnum).default(formaPagamentoComissaoEnum.PagaPelaPlaenge),
    participacoes: z
      .array(
        z.object({
          imobiliariaCorretor: z
            .object({
              idExterno: z.string(),
              descricao: z.string(),
              nome: z.string(),
              tipoImobiliariaCorretor: z.enum(['Imobiliaria', 'CorretorAutonomo', '']),
              documento: z.string(),
            })
            .refine(
              ({ idExterno }) => idExterno,
              t('proposta:detalhes_proposta.imobiliaria.errors.form.selecao_obrigatoria'),
            ),
          corretagem: z.discriminatedUnion('tipo', [
            z.object({
              tipo: z.literal('percentual'),
              percentualCorretagemImobiliaria: z.coerce
                .number<number>()
                .gt(0, t('proposta:detalhes_proposta.imobiliaria.errors.form.valor_invalido'))
                .lte(100, t('proposta:detalhes_proposta.imobiliaria.errors.form.valor_invalido')),
            }),
            z.object({
              tipo: z.literal('valor'),
              valorCorretagemImobiliaria: z
                .number()
                .gt(0, t('proposta:detalhes_proposta.imobiliaria.errors.form.valor_invalido')),
            }),
          ]),
        }),
      )
      .superRefine((participacoes, ctx) => {
        if (!participacoes.length) return z.NEVER
        const contagemImobiliariasContadores = new Map<string, number>()
        participacoes.forEach(({ imobiliariaCorretor }) =>
          contagemImobiliariasContadores.set(
            imobiliariaCorretor.idExterno,
            (contagemImobiliariasContadores.get(imobiliariaCorretor.idExterno) ?? 0) + 1,
          ),
        )
        participacoes.forEach(({ imobiliariaCorretor }, index) => {
          if ((contagemImobiliariasContadores.get(imobiliariaCorretor.idExterno) ?? 0) < 2) return
          ctx.addIssue({
            code: 'custom',
            message: t('proposta:detalhes_proposta.imobiliaria.errors.form.duplicado'),
            path: [index, 'imobiliariaCorretor'],
            input: imobiliariaCorretor,
          })
        })
      }),
  }),
  z.object({
    incluirParticipacoes: z.literal('Não'),
  }),
  z.object({
    incluirParticipacoes: z.literal('').refine(() => false),
  }),
])
export type TImobiliariaCorretoresSchema = z.infer<typeof ImobiliariaCorretoresSchema>

export const detalhesPropostaSchema = z.object({
  detalhesDaProposta: z.object({
    imobiliariasCorretores: ImobiliariaCorretoresSchema,
  }),
})
export type TDetalhesPropostaSchema = z.infer<typeof detalhesPropostaSchema>
